import { render } from "./DetailsHomePage.vue?vue&type=template&id=8e319e82&scoped=true"
import script from "./DetailsHomePage.vue?vue&type=script&lang=js"
export * from "./DetailsHomePage.vue?vue&type=script&lang=js"

import "./DetailsHomePage.vue?vue&type=style&index=0&id=8e319e82&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/gestionale-partner-2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e319e82"]])

export default __exports__